import { IFieldSchemaItem } from './FieldsWidget.properties';

export const selectedId = {
  'customer-enquiry': 'selectedCustomer',
  'inventory-enquiry': 'selectedProduct',
  'pick-slips': 'selectedPickSlip',
};

export const ELEVATION_LEVEL = 2;

export const fieldSchema: IFieldSchemaItem[] = [
  { type: 'FieldData', sequence: 1 },
  { type: 'Email', sequence: 2 },
  { type: 'Link', sequence: 3 },
  { type: 'Mobile', sequence: 4 },
  { type: 'Phone', sequence: 5 },
  { type: 'Fax', sequence: 6 },
  { type: 'Web', sequence: 7 },
];

export const Colours = {
  Amber: '#F47920',
  Blue: '#0E86D4',
  Red: '#B20000',
  Green: '#009E0F'
};

export const FINAL_SEQUENCE_NUMBER = 2;

export const SupportingHref = {
  Email: 'mailto',
  Fax: 'fax',
  Phone: 'tel',
  Mobile: 'tel',
};
